<style lang="less" scoped>
.td_left {width: 200px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
.after {text-align: left;background-color: #fcfcfc;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
tr,td {border: 1px solid #f5eeee;padding: 5px;}
table {border-collapse: collapse;width: 100%;}
/deep/ .el-input .el-input__inner {width: 400px;}
/deep/ .el-textarea .el-textarea__inner {width: 400px;}
.btn_left_td {border-right: none;}
.btn_right_td {border-left: none;}
/deep/ .el-checkbox .el-checkbox__input .el-checkbox__inner {border-radius: 50%;}
/deep/.el-form-item {margin-bottom: 0;}
.btnfixed {margin: 0px auto;height: 60px;z-index: 9999;}
.btnfixed .el-button {height: 40px;margin: 10px auto;}
.btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
/deep/.el-dialog__wrapper {z-index: 20000 !important;}
/deep/.hide .el-upload--picture-card {display: none;}
</style>
<template>
  <div class="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('title')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>证书标题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.title" placeholder="请输入标题" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
        <td class="td_left">
          <span v-if="isMandatory('content')" class="f_red">*</span>
          <span v-else class="f_hid">*</span>内容
        </td>
        <td class="after">
          <el-form-item>
            <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.content" class="Category_name"></el-input>
          </el-form-item>
        </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>证书图片
          </td>
          <td class="after">
            <el-upload
              v-if="this.$route.path === '/QyzsUpdate'"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              @mouseover.native="getPhoUrl"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :on-exceed="exceed">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :file-list="fileList1"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              @mouseover.native="getPhoUrl"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :on-exceed="exceed">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width=100% />
            </el-dialog>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('authority')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>发证机构
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input
                v-model="form.authority"
                placeholder="请输入标题"
                class="input title"
              >
              </el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr">
          <td class="td_left">
            <span v-if="isMandatory('fromtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>发证日期
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.fromtime" value-format="timestamp" type="datetime"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr">
          <td class="td_left">
            <span v-if="isMandatory('totime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>到期日期
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.totime" value-format="timestamp" type="datetime"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr" v-if="this.$route.path === '/QyzsUpdate'">
          <td class="td_left">
            <span v-if="isMandatory('addtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>添加时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.addtime" value-format="timestamp" type="datetime" placeholder="请选择添加时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr" v-else>
          <td class="td_left">
            <span v-if="isMandatory('edittime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>修改时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.edittime" value-format="timestamp" type="datetime" placeholder="请选择修改时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addData" v-if="this.$route.path === '/QyzsUpdate'">添加</el-button>
      <el-button type="success" @click="modification()" v-else>确定修改</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/QyzsUpdate'">取消</el-button>
      <el-button @click="backtrack()" v-else>返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 李旭
 * 线上云展-企业荣誉资质添加
 */
import {mapState} from 'vuex'
export default {
  props: ['updataID', 'ryzzID'],
  data()
  {
    return {
      url: '',
      moduleid: null,
      form: {
        title: '',
        content: '',
        authority: '',
        fromtime: '',
        totime: '',
        addtime: '',
        edittime: '',
        examine: 1
      },
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList1: [{url: ''}],
      //表名
      tabname: 'dmcn_honor',
      //fld表数据
      fldData: [],
      hideUploadEdit: false
    }
  },
  computed:
  {
    ...mapState({
      id: state => state.NavID // 菜单ID
    })
  },
  watch:
  {
    id:
    {
      handler(nval, oval)
      {
        this.moduleid = nval
      },
      immediate: true
    }
  },
  async created()
  {
    this.isgetData()
    this.fldData = await window.public.validation(this.tabname)
  },
  methods: {
    //添加
    addData()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 47,
        retAtt: 1,
        title: this.form.title,
        content: this.form.content,
        authority: this.form.authority,
        fromtime: (this.form.fromtime / 1000),
        totime: (this.form.totime / 1000),
        addtime: (Date.parse(new Date()) / 1000),
        edittime: (Date.parse(new Date()) / 1000),
        thumb: this.form.thumb,
        companyid: this.updataID,
        examine: this.form.examine
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
      })
    },
    //需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/QyzsZzlbUpdata')
        this.getData()
      else if (this.$route.path === '/QyzsUpdate')
        return false
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 47,
        _exp: 'id=?',
        types: 'i',
        vals: this.ryzzID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.title = ret[0].title
        this.form.content = window.public.decodeContent(ret[0].content)
        this.form.thumb = ret[0].thumb !== '' ? ret[0].thumb : 'static/images/moren.jpg'
        this.fileList1[0].url = ret[0].thumb
        this.form.authority = ret[0].authority
        this.form.fromtime = ret[0].fromtime * 1000
        this.form.totime = ret[0].totime * 1000
        this.form.edittime = ret[0].edittime * 1000
      })
    },
    //确认修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 47,
        retAtt: 1,
        id: this.form.id,
        title: this.form.title,
        content: this.form.content,
        authority: this.form.authority,
        fromtime: (this.form.fromtime / 1000),
        totime: (this.form.totime / 1000),
        edittime: (Date.parse(new Date()) / 1000),
        thumb: this.form.thumb
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/Qyzsgl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    // 返回
    backtrack()
    {
      this.$router.push({path: '/Qyzsgl'})
      this.$store.commit('onActiveName', '1')
    },
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/xsyz/QyzsRyzz.vue